import axios from 'axios';

const SsoProvider = axios.create({
    baseURL: process.env.BASE_URL
        ? process.env.BASE_URL
        : '/'
});

export default SsoProvider;
